import { GraphQlClient, Http, Url } from '@intelipost-js/secure-providers';
import { ScToast, ScDialog } from '@intelipost-js/secure-components';

export default {
  getAccessGroups({ commit }) {
    commit('setLoading', true);
    return GraphQlClient.query(`
    query{
      getAccessGroups{
        id
        name
      }
    }`)
    .then(({ data }) => {
      const { getAccessGroups: groups } = data;
      commit('setAccessGroups', groups || []);
      commit('setLoading', false);
      return Promise.resolve(data);
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },

  getAccessGroup({ commit }, groupId) {
    commit('setLoading', true);
    return GraphQlClient.query(`
    query(
      $groupId: Int
    ){
      getAccessGroup(
        id: $groupId
      ) {
        id
        externalId
        name
        description
        modules {
          id
          name
          screens {
            id
            name,
            resources {
              id
              role
              active
            }
          }
        }
      }
    }
    `, { groupId })
    .then(({ data }) => {
      const { getAccessGroup: group } = data;
      const { modules: dataModules } = group;
      if (group && dataModules && dataModules.length) {
        group.modules = dataModules
          .filter(module => module.screens && module.screens.length);
        group.modules = group
          .modules.map((module) => {
            const newScreens = module
            .screens.map((screen) => {
              if (screen.resources && screen.resources.length) {
                const isAllResourcesChecked = !screen
                .resources
                .find(resource => !resource.active);
                return Object.assign(screen, { isAllResourcesChecked });
              }
              return screen;
            });
            return Object.assign(module, { screens: newScreens });
          });
      }
      commit('setAccessGroup', group || {});
      commit('setLoading', false);
      return Promise.resolve(data);
    })
    .catch((err) => {
      commit('setAccessGroup', {});
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },

  createAccessGroup({ commit }, group) {
    commit('setLoading', true);
    return GraphQlClient.mutation(`
    mutation (
      $externalId: String!
      $name: String!
      $description: String
      $resourceIds: [Int]!
    ) {
      createAccessGroup (
        externalId: $externalId
        name: $name
        description: $description
        resourceIds: $resourceIds
      ) {
        id
      }
    }`, group)
    .then(({ data }) => {
      commit('setLoading', false);
      ScToast.success('Grupo de acesso criado com sucesso!');
      return Promise.resolve(data);
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },

  updateAccessGroup({ commit }, group) {
    commit('setLoading', true);

    return GraphQlClient.mutation(`
    mutation (
      $id: Int!
      $externalId: String!
      $name: String!
      $description: String
      $resourceIds: [Int]!
    ) {
      updateAccessGroup (
        id: $id
        externalId: $externalId
        name: $name
        description: $description
        resourceIds: $resourceIds
      ) {
        id
      }
    }`, group)
    .then(({ data }) => {
      commit('setLoading', false);
      ScToast.success('Grupo de acesso atualizado com sucesso!');
      return Promise.resolve(data);
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },

  removeAccessGroup({ commit, dispatch }, group) {
    ScDialog.confirm({
      title: 'Tem certeza?',
      message: `Realmente gostaria de excluir o grupo <strong>${group.name}</strong> ?`,
      confirmText: 'Excluir grupo',
      type: 'is-danger',
      hasIcon: true,
      icon: 'times-circle',
      onConfirm: () => {
        commit('setLoading', true);
        return GraphQlClient.mutation(`
        mutation (
          $id: Int!
        ) {
          removeAccessGroup (
            id: $id
          ) {
            id
          }
        }`, group)
        .then(() => dispatch('getAccessGroups'))
        .then((res) => {
          commit('setLoading', false);
          ScToast.success('Grupo excluído com sucesso.');
          return Promise.resolve(res);
        })
        .catch((err) => {
          commit('setLoading', false);
          return Promise.reject(err);
        });
      },
    });
  },
  getPermissions({ commit }) {
    return Http.get('api/v1/company/permissions/list')
      .then((res) => {
        const listPermissions = res.data.content;
        commit('setPermissions', listPermissions);
        return res;
      });
  },
  getGroups({ commit }) {
    commit('setLoading', true);
    return Http.get('api/v1/user_group/list')
      .then((res) => {
        commit('setLoading', false);
        commit('setGroups', res.data.content);
        return res;
      })
      .catch((err) => {
        commit('setLoading', false);
        throw err;
      });
  },
  getGroup({ commit }, groupId) {
    commit('setLoading', true);
    return Http.get(Url.toQueryString('api/v1/user_group', null, [groupId]))
      .then((res) => {
        const { data = {} } = res || {};
        const { content = {} } = data || {};
        const { permissions = {} } = content || {};
        commit('setLoading', false);
        commit('setGroup', Object.assign(content, permissions));
        return res;
      })
      .catch((err) => {
        commit('setLoading', false);
        throw err;
      });
  },
  createGroup({ commit, state }) {
    commit('setLoading', true);
    return Http.post('api/v1/user_group/add', state.group)
      .then((res) => {
        commit('setLoading', false);
        ScToast.success('Grupo criado com sucesso');
        return res;
      })
      .catch((err) => {
        commit('setLoading', false);
        throw err;
      });
  },
  updateGroup({ commit, state }) {
    commit('setLoading', true);
    return Http.put(Url.toQueryString('api/v1/user_group', null, [state.group.id]), state.group)
      .then((res) => {
        commit('setLoading', false);
        ScToast.success('Grupo atualizado com sucesso');
        return res;
      })
      .catch((err) => {
        commit('setLoading', false);
        throw err;
      });
  },
  removeGroup({ commit, dispatch }, group) {
    ScDialog.confirm({
      title: 'Tem certeza?',
      message: `Realmente gostaria de excluir o grupo <strong>${group.name}</strong> ?`,
      confirmText: 'Excluir grupo',
      type: 'is-danger',
      hasIcon: true,
      icon: 'times-circle',
      onConfirm: () => {
        commit('setLoading', true);
        return Http.delete(Url.toQueryString('api/v1/user_group', null, [group.id]))
          .then(() => dispatch('getGroups'))
          .then((res) => {
            commit('setLoading', false);
            ScToast.success('Grupo excluído com sucesso.');
            return res;
          })
          .catch((err) => {
            commit('setLoading', false);
            throw err;
          });
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/access-groups/store/actions.js